export default __webpack_public_path__ + "static/media/vueMovie.500ac553.png";